import React, {useState} from 'react';
import styles from './styles.module.scss';
import Text from 'components/typografy/text';
import classNames from 'classnames';
import {DialogRoot, DialogTrigger} from '@chakra-ui/react';
import Dialog from 'components/dialog';
import Withdrawal from '../../withdrawal';
import {IVendorNames} from 'types/payment';

const Item: React.FC<{
  title: string;
  image: string;
  type: IVendorNames;
  minPrice: string;
  maxPrice: string;
  bonus: string | null;
}> = ({title, image, type, minPrice, maxPrice, bonus}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <DialogRoot
      scrollBehavior="inside"
      size="lg"
      open={isOpen} // <--- this is CRITICAL to control the open state
      onOpenChange={() => { setIsOpen(!isOpen); }}
      placement="center"
    >
      <div className={styles.wrapper}>
        <DialogTrigger>
          {bonus && <div className={styles.bonus}>{bonus}</div>}
          {/* <Text variant={'medium'} nativeClassname={styles.title}>
            <>{title}</>
          </Text> */}
          <div className={classNames(styles.image, styles[type])}>
            <img src={image} alt={title} />
          </div>
          <div className={styles.row}>
            <Text variant={'small'} nativeClassname={styles.white}>
              <>Minimum ${minPrice}</>
            </Text>
          </div>
          <div className={styles.hr} />
        </DialogTrigger>
        <Dialog isOpen={isOpen}>
          <Withdrawal 
            title={title} 
            image={image} 
            type={type}
            onClose={() => setIsOpen(false)} // pass down a way to close the modal
          />
        </Dialog>
      </div>
    </DialogRoot>
  );
};

export default Item;
